import * as firmware from "./firmware";
import * as firmwareVersion from "./firmwareVersion";
import * as skuFirmware from "./skuFirmware";

export const device = {
  firmware,
  firmwareVersion,
  skuFirmware,
};
